import { DatePicker, FormControl } from '@airbus/components-react';

type BulkUpdateDateInputProps = {
  id: string;
  value: Date | null;
  onChange: (value: Date | null) => void;
  onBlur?: () => void;
  disabled?: boolean;
  hasError?: boolean;
  errorMessage?: string;
  minDate?: Date | null;
  maxDate?: Date | null;
};

export default function BulkUpdateDateInput({
  id,
  value,
  onChange,
  onBlur,
  disabled = false,
  hasError = false,
  errorMessage,
  minDate = null,
  maxDate = null,
}: BulkUpdateDateInputProps) {
  return (
    <FormControl
      id={id}
      disabled={disabled}
      error={hasError || Boolean(errorMessage)}
      helpText={errorMessage || undefined}
      errorText={errorMessage || undefined}
      className='input-small disabled-input'
    >
      <DatePicker
        value={value}
        disabled={disabled}
        onChange={(next) => {
          if (!next) {
            onChange(null);
            return;
          }
          onChange(Array.isArray(next) ? next[0] ?? null : next);
        }}
        onBlur={onBlur}
        minDate={minDate ?? undefined}
        maxDate={maxDate ?? undefined}
        dateFormat='DD/MM/YYYY'
        datePattern='[0-9]{2}/[0-9]{2}/[0-9]{4}'
        dateSeparator='/'
      />
    </FormControl>
  );
}
